"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSelect = _interopRequireDefault(require("react-select"));
var _Button = require("b2b-components/theme/components/Button");
var _Label = require("b2b-components/theme/components/Form/Label");
var _Icon = require("b2b-components/theme/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
var _Error = require("../../common/Error");
var _Info = require("../../common/Info");
var _Control = require("./Control");
var _Option = require("./Option");
var _SingleValue = require("./SingleValue");
require("./SelectButton.scss");
const SelectButton = _ref => {
  let {
    selectButtonId,
    className,
    onChange,
    options,
    error = null,
    info = null,
    markingType = _Label.MARKING_TYPE.none,
    text = {
      deliveryHours: '',
      label: '',
      placeholder: '',
      required: '*',
      optional: '(optional)',
      buttonTextDefault: 'Ship later...',
      buttonText: 'Change...'
    },
    value,
    isOpen,
    toggleIsOpen
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-Form-Input', {
    'cds-Form-Input--Error': error
  }, className);
  const isDefault = value.value === options[0]?.value;
  const onMenuClose = () => toggleIsOpen?.(false);
  const ButtonIndicator = () => /*#__PURE__*/_react.default.createElement(_Button.Button, {
    className: "cds-SelectButton-Indicator",
    onClick: () => toggleIsOpen?.(),
    onTouchEnd: () => toggleIsOpen?.(),
    styleType: _Button.BUTTON_STYLE_TYPE.blank
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    name: _Icon.ICON_NAME.delivery,
    className: "cds-SelectButton-IndicatorIcon"
  }), isDefault ? text.buttonTextDefault : text.buttonText);
  const commonProps = {
    id: selectButtonId,
    className: 'cds-SelectButton',
    deliveryHours: text.deliveryHours,
    value: value,
    options,
    classNamePrefix: 'cds-SelectButton',
    onChange,
    onMenuClose,
    menuIsOpen: isOpen,
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    isClearable: false,
    isSearchable: false,
    openMenuOnClick: false,
    openMenuOnFocus: false,
    components: {
      DropdownIndicator: ButtonIndicator,
      Control: _Control.Control,
      Option: _Option.Option,
      SingleValue: _SingleValue.SingleValue,
      IndicatorSeparator: null
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName
  }, text.label && /*#__PURE__*/_react.default.createElement(_Label.Label, {
    markingType: markingType,
    text: text,
    className: "cds-Form-Label cds-SelectButton-Label",
    htmlFor: selectButtonId
  }, text.label), /*#__PURE__*/_react.default.createElement(_reactSelect.default, commonProps)), error && /*#__PURE__*/_react.default.createElement(_Error.Error, null, error), info && /*#__PURE__*/_react.default.createElement(_Info.Info, null, info));
};
exports.SelectButton = SelectButton;
//# sourceMappingURL=SelectButton.js.map